export default __webpack_public_path__ + "static/media/badge_hour.704e28cb.svg";